exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.tw-news_news_uzo3T {\n    background: var(--motion-tertiary);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.375rem 0;\n    gap: 0.5rem;\n}\n\n.tw-news_text_1P6mJ {\n    flex-grow: 1;\n    color: white;\n    text-align: center;\n}\n\n.tw-news_text_1P6mJ a {\n    color: inherit;\n}\n\n.tw-news_close_yCgKk {\n    flex-shrink: 0;\n    margin-right: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"news": "tw-news_news_uzo3T",
	"text": "tw-news_text_1P6mJ",
	"close": "tw-news_close_yCgKk"
};